var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBinIcon = function SvgBinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e81c5c",
    "data-name": "Group 2935"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 15a1 1 0 0 0 1-1V9a1 1 0 0 0-2 0v5a1 1 0 0 0 1 1",
    "data-name": "Path 29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15a1 1 0 0 0 1-1V9a1 1 0 0 0-2 0v5a1 1 0 0 0 1 1",
    "data-name": "Path 30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 2h-3.286C13.055.814 11.257 0 9 0S4.945.814 4.286 2H1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-3 14H4V7h10Zm2-11H2V4h14Z",
    "data-name": "Path 31"
  }))));
};
export default SvgBinIcon;